/**
 * @author Ka Wing Chin <kawing.chin@takeaway.com>
 * @class Takeaway.ProductSize
 * The product size
 */

export default class ProductSize {
  constructor (obj) {
    if (obj !== undefined) {
      for (let prop in obj) {
        this[prop] = obj[prop]
      }
    }
  }

  id
  sizeName
  price = 0
  pricePickup = 0
  deliveryType
  ignoreMinimumOrderValue = false
  /**
   * @property {Array<SideDish>} An array of sidedishes.
   */
  sideDishes
}
